const typegraphy = {
    fontFamily: `"Poppins", sans-serif`,
    h1: {
        fontFamily: `"Circular Std", sans-serif`,
        fontSize: 64,
        fontWeight: 'bold'
    },
    h2: {
        fontFamily: `"Circular Std", sans-serif`,
        fontSize: 48,
        fontWeight: 'bold'
    },
    h3: {
        fontSize: 32,
        fontWeight: '500'
    },
    h4: {},
    h5: {},
    h6: {},
    caption: {
        fontFamily: `"Circular Std", sans-serif`,
        fontSize: 18,
        fontWeight: 'medium'
    },
    subtitle2: {
        fontFamily: `"Circular Std", sans-serif`,
        fontSize: 14,
        fontWeight: 'Bold'
    },
    button: {
        fontFamily: `"Circular Std", sans-serif`,
        fontSize: 18,
        fontWeight: 'bold',
        textTransform: 'none'
    },
    body1: {
        fontSize: 16
    }
}

export default typegraphy
